export default __webpack_public_path__ + "static/media/10.96f9f357.png";